import React, { useEffect, useRef, useState } from 'react';
import useScrollAnimation from './UseScrollAnimation';

const depoimentos = [
  {
    nome: "JOÃO",
    empresa: "HO – Uberlândia/MG",
    texto: "O que falar da Usifresa? Pessoal atencioso, ótimo atendimento e oferece máquinas de muita qualidade e inovação. Consideramos uma importante empresa para dar continuidade ao crescimento e às melhorias constantes deste mercado. Aproveitamos para parabenizar a todos que formam esta grande equipe!"
  },
  {
    nome: "MARCOS",
    empresa: "Papersul – Vila Maria/RS",
    texto: "Renovamos nosso maquinário com a Usifresa e ficamos muito satisfeitos com a parceria, que compreende desde o bom atendimento comercial até o pós-vendas. Contam com profissionais qualificados, oferecendo suporte completo para atender as necessidades do cliente."
  },
  {
    nome: "JUNIOR",
    empresa: "Seccar – Belo Horizonte/MG",
    texto: "Somos da Seccar e temos uma parceria de mais de 10 anos com a Usifresa, uma empresa que preza pela qualidade and produtividade de todas as suas máquinas. Possuem um atendimento personalizado excepcional, demonstrando zelo e atenção com seus clientes e oferecendo excelente suporte às máquinas instaladas."
  },
  {
    nome: "CESAR",
    empresa: "Parpel – Cabedelo/PB",
    texto: "Gosto de comprar máquinas da Usifresa por usarem peças de qualidade e robustez, garantindo longa duração e facilidade em futuras manutenções. Além disso, as peças para reposição são sempre idênticas às originais e estão sempre disponíveis para envio imediato. O atendimento é de primeira!"
  },
  {
    nome: "EDSON",
    empresa: "Sol Papel – Magé/RJ",
    texto: "Uma empresa parceira que entende a necessidade do cliente. Hoje, temos um maquinário de ótima qualidade e com excelente suporte de manutenção, o que nos proporciona tranquilidade na reposição de peças."
  },
  {
    nome: "PAULO",
    empresa: "Domus Paper – Rio de Janeiro/RJ",
    texto: "Interfolhadeiras Usifresa: qualidade diferenciada e satisfação com os produtos acabados… Parabéns a vocês!!!!"
  }
];

const Testemomial = () => {
  useScrollAnimation();

  return (
    // py-16 no mobile e py-24 a partir de md para dosar o tamanho das seções no celular
    <section className="bg-gray-50 py-16 md:py-24 overflow-hidden reveal">
      {/* px-4 no mobile para expandir a área útil */}
      <div className="container mx-auto px-4 sm:px-6 md:px-12">
        
        {/* Nova tag inserida aqui, substituindo a antiga linha */}
        <div className="flex items-center gap-4 mb-6">
          <span className="w-12 h-[3px] bg-usifresa-orange"></span>
          <span className="text-xs md:text-sm font-black text-usifresa-blue uppercase tracking-[0.3em]">
            Depoimentos
          </span>
        </div>
        
        {/* h2 ajustado para text-3xl no mobile e mb-8 para aproximar do grid */}
        <h2 className="text-3xl md:text-5xl font-sans font-black text-usifresa-blue mb-8 md:mb-16 leading-tight">
          Depoimentos de <br className="hidden md:block"/>nossos clientes
        </h2>

        {/* gap-6 no mobile para os cards não ficarem colados, mas sem exagerar */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {depoimentos.map((dep, index) => (
            <div 
              key={index} 
              // Alterado p-8 para p-5 no mobile
              className="bg-white p-5 sm:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-300 flex flex-col h-full animate-[slideFadeIn_1s_ease-out_forwards]"
              style={{ animationDelay: `${index * 0.15}s`, opacity: 0 }}
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 rounded-full bg-gradient-custom flex items-center justify-center text-white font-bold text-xl shadow-md shrink-0">
                  {dep.nome.charAt(0)}
                </div>
                <div>
                  <h3 className="font-bold text-usifresa-blue text-lg leading-none">{dep.nome}</h3>
                  <div className="flex gap-1 mt-1.5">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-4 h-4 text-usifresa-orange" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                </div>
              </div>
              
              {/* Ajustado o posicionamento absoluto das aspas no text-sm do mobile */}
              <p className="text-gray-800 italic leading-relaxed text-sm md:text-base flex-grow mb-6 relative">
                <span className="text-4xl text-gray-200 absolute -top-3 -left-1 select-none">"</span>
                <span className="relative z-10 block px-2">{dep.texto}</span>
                <span className="text-4xl text-gray-200 absolute -bottom-5 -right-1 select-none">"</span>
              </p>
              
              <h4 className="text-sm font-semibold text-usifresa-orange uppercase tracking-wider border-t border-gray-100 pt-4 mt-auto">
                {dep.empresa}
              </h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testemomial;